var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentFailedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 752.1 738.9",
    style: {
      enableBackground: "new 0 0 752.1 738.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5E5E5E;}\r\n\t.st1{fill:#F8F8F8;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#2D8E8D;}\r\n\t.st4{fill:none;stroke:#2D8E8D;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st5{fill:#FED892;}\r\n\t.st6{fill:#FF5722;}\r\n\t.st7{fill:none;stroke:#2D8E8D;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "travel-tickets-colour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471.9,286.4l52.4,5.6l199.9,21.3l0.5,0l0.7,0.1c13.8,2.2,23.3,17.3,21.5,34.3l-36.9,345.8 c-0.7,7.8-4,15.1-9.3,20.8c-5,5.3-11.3,8.2-17.8,8.2h-1.2h-0.5l-0.7-0.1l-199.9-21.4l-52.4-5.6L471.9,286.4 M470.4,284.6 l-44,412.5l54.1,5.8l199.9,21.3l1.2,0.1l0,0h1.3c14.3,0,26.9-13.1,28.7-30.5l36.9-345.8c1.9-17.9-8.3-33.8-22.9-36.1l0,0l-1.2-0.1 l-199.9-21.4L470.4,284.6L470.4,284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566.2,108.5c29.6,43.7,26.1,107.8,53.3,179c27,71.2,84.7,149.1,83.5,232.7c-1,83.5-61,172.4-140.3,195.5 c-79.1,23.2-177.5-19.8-257.8-68C224.5,599.3,162,545.6,105.1,475C48.1,404.5-3.5,317.1,0.2,229.8C4,142.7,63.3,55.3,141,20.3 s173.8-18.1,253.4,1.9C473.8,42,536.6,64.8,566.2,108.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.1,675.1c-9.8,0-18.1-7.3-19.4-17L203.1,74c-1.4-10.7,6.1-20.6,16.8-22l257.9-34.2 c0.9-0.1,1.7-0.2,2.6-0.2c9.8,0,18.1,7.3,19.4,17l77.6,584.1c1.4,10.7-6.1,20.6-16.8,22l-257.9,34.2 C301.9,675,301,675.1,300.1,675.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M480.5,18.5c9.4,0,17.3,7,18.5,16.2l77.6,584.1c1.3,10.2-5.9,19.6-16.1,21l-257.9,34.3 c-0.8,0.1-1.6,0.2-2.5,0.2c-9.4,0-17.3-7-18.5-16.2L204,73.9c-1.3-10.2,5.8-19.6,16.1-21L478,18.7 C478.8,18.5,479.6,18.5,480.5,18.5 M480.5,16.8c-0.9,0-1.8,0.1-2.7,0.2L219.9,51.2c-11.2,1.5-19,11.7-17.5,22.9l77.6,584.1 c1.4,10.1,10,17.7,20.2,17.7c0.9,0,1.8-0.1,2.7-0.2l257.9-34.3c11.1-1.5,19-11.8,17.5-22.9L500.7,34.5 C499.3,24.4,490.7,16.8,480.5,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M537.4,644.6l23.4-3.1c11.1-1.5,19-11.8,17.5-22.9L500.7,34.5c-1.5-11.1-11.8-19-22.9-17.5l-23.4,3.1 L537.4,644.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 499.3,
    y1: 229,
    x2: 227.7,
    y2: 265.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 345,
    cy: 142.1,
    r: 70
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.2,
    y: 110.3,
    transform: "matrix(0.6078 -0.7941 0.7941 0.6078 21.3623 335.546)",
    className: "st3",
    width: 10.4,
    height: 71.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "386,173.4 382,163.9 375.8,172.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "363.9,150 364.6,109.1 357.4,103.6 346.1,136.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "326.9,128.2 327.2,111.6 324.3,109.3 319.7,122.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "357.6,158.2 318.3,169.6 311.1,164.1 339.8,144.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "326.9,128.2 310.9,132.8 308,130.6 319.7,122.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.8,
    y: 268.3,
    transform: "matrix(0.9915 -0.1302 0.1302 0.9915 -51.6035 62.9377)",
    className: "st6",
    width: 19.6,
    height: 315.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.3,
    y: 275.6,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -45.8686 56.6361)",
    className: "st6",
    width: 19.6,
    height: 198.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 336.1,
    y1: 269.4,
    x2: 386.2,
    y2: 646.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 290.3,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -36.1185 40.5119)",
    className: "st0",
    width: 34.3,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.1,
    y: 351.6,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -44.1268 42.1198)",
    className: "st0",
    width: 34.3,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 385.9,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -48.598 43.0174)",
    className: "st0",
    width: 34.3,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.5,
    y: 437.1,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -55.2877 44.36)",
    className: "st0",
    width: 34.3,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.1,
    y: 308,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -39.1781 41.1264)",
    className: "st0",
    width: 34.3,
    height: 17.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.9,
    y: 359.6,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -45.9081 42.4768)",
    className: "st0",
    width: 34.3,
    height: 17.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.4,
    y: 415.5,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -53.2162 43.9444)",
    className: "st0",
    width: 34.3,
    height: 17.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.6,
    y: 459.4,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -58.3822 44.9818)",
    className: "st0",
    width: 34.3,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.2,
    y: 301.6,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -37.3662 40.7625)",
    className: "st0",
    width: 34.3,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.8,
    y: 491.9,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -62.4486 45.7981)",
    className: "st0",
    width: 34.3,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.6,
    y: 507.7,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -65.2498 46.3608)",
    className: "st0",
    width: 34.3,
    height: 17.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.8,
    y: 501.3,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -63.4376 45.9983)",
    className: "st0",
    width: 34.3,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.3,
    y: 445.3,
    transform: "matrix(0.9913 -0.1317 0.1317 0.9913 -56.1249 44.529)",
    className: "st0",
    width: 34.3,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.7,
    y: 453.7,
    transform: "matrix(0.9915 -0.1302 0.1302 0.9915 -56.5758 44.2051)",
    className: "st0",
    width: 34.2,
    height: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.1,738.1c-10.6,0-19.9-7.1-22.7-17.3l-87.9-321c-3.4-12.5,4-25.4,16.5-28.9l39-10.7 c8.1,27.3,36.7,42.9,64.1,34.9c26.6-7.8,42.2-35.3,35.4-62.1l39-10.7c12.5-3.4,25.4,3.9,28.9,16.4c0,0,0,0,0,0.1l87.9,321 c3.4,12.5-4,25.4-16.5,28.9l-39,10.7c-7.9-27.4-36.5-43.1-63.9-35.2c-26.8,7.7-42.6,35.4-35.6,62.5l-39,10.7 C149.3,737.8,147.2,738.1,145.1,738.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M234.7,322.3c10.2,0,19.1,6.8,21.8,16.7l87.9,321c3.3,12.1-3.8,24.5-15.9,27.8c0,0,0,0,0,0l-38.2,10.5 c-8.4-27.7-37.7-43.3-65.4-34.8c-26.6,8.1-42.2,35.5-35.6,62.5l-38.2,10.5c-12.1,3.3-24.5-3.8-27.8-15.8c0,0,0,0,0,0l-87.9-321 c-3.3-12.1,3.8-24.5,15.9-27.8l38.2-10.5c8.2,27.8,37.4,43.6,65.1,35.4c27-8,42.8-35.8,36-63.1l38.2-10.5 C230.7,322.6,232.7,322.4,234.7,322.3 M234.7,320.7c-2.2,0-4.3,0.3-6.4,0.9l-39.8,10.9c0.1,0.2,0.1,0.3,0.1,0.5 c7.4,27-8.5,54.9-35.5,62.3s-54.9-8.5-62.3-35.5l0,0c0-0.2-0.1-0.3-0.1-0.5l-39.8,10.9c-13,3.6-20.6,16.9-17.1,29.9l87.9,321 c3.5,13,16.9,20.6,29.9,17.1c0,0,0,0,0,0l39.8-10.9c-7.4-27,8.5-54.9,35.5-62.3s54.9,8.5,62.3,35.5l39.8-10.9 c13-3.6,20.6-16.9,17.1-29.9l-87.9-321C255.3,328,245.7,320.7,234.7,320.7L234.7,320.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.9,
    y: 539.9,
    transform: "matrix(0.9645 -0.264 0.264 0.9645 -150.8864 58.3867)",
    className: "st0",
    width: 3.8,
    height: 101.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.1,
    y: 529.7,
    transform: "matrix(0.9645 -0.264 0.264 0.9645 -146.871 67.8641)",
    className: "st0",
    width: 3.8,
    height: 101.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.2,
    y: 516.6,
    transform: "matrix(0.9645 -0.264 0.264 0.9645 -141.6889 80.0891)",
    className: "st0",
    width: 3.8,
    height: 101.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.7,
    y: 536.2,
    transform: "matrix(0.9645 -0.264 0.264 0.9645 -149.4348 61.8132)",
    className: "st0",
    width: 11.1,
    height: 101.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 527.4,
    transform: "matrix(0.9645 -0.264 0.264 0.9645 -145.9469 70.0437)",
    className: "st0",
    width: 11.1,
    height: 101.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.8,
    y: 519,
    transform: "matrix(0.9645 -0.264 0.264 0.9645 -142.6319 77.8707)",
    className: "st0",
    width: 11.1,
    height: 101.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.1,
    y: 513.3,
    transform: "matrix(0.9645 -0.264 0.264 0.9645 -140.4237 83.0809)",
    className: "st0",
    width: 5.6,
    height: 101.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.1,
    y: 506.8,
    transform: "matrix(0.9652 -0.2614 0.2614 0.9652 -136.7644 86.0312)",
    className: "st0",
    width: 3.8,
    height: 100.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.3,
    y: 504.3,
    transform: "matrix(0.9645 -0.264 0.264 0.9645 -136.8612 91.4825)",
    className: "st0",
    width: 11.1,
    height: 101.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.4,
    y: 506.7,
    transform: "matrix(0.9645 -0.264 0.264 0.9645 -137.8002 89.2667)",
    className: "st0",
    width: 1.5,
    height: 101.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.5,
    y: 514.8,
    transform: "matrix(0.9652 -0.2614 0.2614 0.9652 -139.6445 80.3575)",
    className: "st0",
    width: 1.5,
    height: 100.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.7,
    y: 457.4,
    transform: "matrix(0.9645 -0.264 0.264 0.9645 -118.9429 49.4776)",
    className: "st3",
    width: 91.7,
    height: 19.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.3,
    y: 489.5,
    transform: "matrix(0.9645 -0.264 0.264 0.9645 -126.6937 46.1286)",
    className: "st3",
    width: 45.9,
    height: 9.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -239.3715 605.1525)",
    className: "st6",
    cx: 235.9,
    cy: 443.3,
    rx: 25.1,
    ry: 25.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.4,
    y: 279,
    transform: "matrix(0.1638 -0.9865 0.9865 0.1638 154.113 941.1494)",
    className: "st6",
    width: 251.6,
    height: 201.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M664.7,721.5c-0.4,0-0.8,0-1.2,0h-0.7l-253.6-27L453,283.6l254,27.1l0.4,0.1c14.3,2.3,24,17.7,22.2,35.2 l-36.9,345.8C690.9,708.4,678.6,721.5,664.7,721.5L664.7,721.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.7,284.5l52.4,5.6L706,311.4h0.5l0.7,0.1c13.8,2.2,23.3,17.3,21.5,34.3l-36.9,345.8 c-0.7,7.8-4,15.1-9.3,20.8c-5,5.3-11.3,8.2-17.8,8.2c-0.4,0-0.8,0-1.2,0H663l-0.7-0.1l-199.9-21.3l-52.4-5.6L453.7,284.5  M452.2,282.6l-44,412.5l54.1,5.8l199.9,21.3l1.2,0.1l0,0h1.3c14.3,0,26.9-13.1,28.7-30.5L730.3,346c1.9-17.9-8.3-33.8-22.9-36.1 l0,0l-1.2-0.1l-199.9-21.3L452.2,282.6L452.2,282.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "579.3,420 482.2,553.3 646.2,570.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569.6,
    y: 306.5,
    transform: "matrix(0.1061 -0.9944 0.9944 0.1061 137.9991 925.2471)",
    className: "st3",
    width: 28.1,
    height: 158.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 569.7,
    cy: 516.2,
    r: 74.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailedIcon);
export default __webpack_public_path__ + "static/media/payment-failed-icon.7e8a4d75e3205ec2e97e7f6e5aa78d5a.svg";
export { ForwardRef as ReactComponent };